
import { computed, defineComponent } from 'vue';
import agentsStore from '../agents.store';

export default defineComponent({
    name: 'AgentsInfoBar',
    setup() {
        const isImpersonating = computed(() => {
            return agentsStore.isImpersonating;
        });

        const impersonatedUserAccountName = computed(() => {
            return agentsStore.impersonatedUserAccountName;
        });

        const unImpersonate = agentsStore.unImpersonate;

        return {
            isImpersonating,
            unImpersonate,
            impersonatedUserAccountName,
        };
    },
});
